<template>
    <div>
        <v-data-table
            :headers="headersSelecionados"
            :items="value"
            hide-actions
        >
            <template slot="items" slot-scope="props">
                <tr>
                    <td>{{ props.item.data }}</td>
                    <td v-if="tipo === 'Esclarecimento'">
                        <expandir-texto :texto="props.item.assunto" tamanho="50"></expandir-texto>
                    </td>
                    <td v-if="tipo === 'Esclarecimento'">
                        <expandir-texto :texto="props.item.mensagem" tamanho="150"></expandir-texto>
                    </td>
                    <td v-else>
                        <expandir-texto :texto="props.item.mensagem" tamanho="200"></expandir-texto>
                    </td>
                    <td>
                        <a class="az-action-link-icon" target="_blank" v-if="props.item.anexo"
                           @click.prevent="downloadAnexo(props.item.anexo)">
                            Baixar Anexo
                            <v-icon size="20px">download</v-icon>
                        </a>
                        <span v-else>--</span>
                    </td>
                    <td>
                        <a v-if="props.item.resposta.id" @click="abrirModalRespostas(props.item.resposta, tipo)"
                           title="Ver Resposta">
                            <v-icon>search</v-icon>
                        </a>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import ExpandirTexto from '@/commons/components/ExpandirTexto'

export default {
    name: 'DetalheEsclarecimentoImpugnacaoTabela',
    components: {ExpandirTexto},
    props: {
        value: {
            required: true
        },
        tipo: {
            type: String
        }
    },
    data() {
        return {
            headersEsclarecimento: [
                {text: "Data", value: "data", width: '5%', sortable: false, class: 'primary--text'},
                {text: "Assunto", value: "assunto", width: '25%', sortable: false, class: 'primary--text'},
                {text: "Conteúdo", value: "mensagem", width: '55%', sortable: false, class: 'primary--text'},
                {text: "Anexo", value: "url", width: '15%', sortable: false, class: 'primary--text'},
                {text: 'Respostas', align: 'center', width: '2%', sortable: false, class: 'primary--text'}
            ],
            headersImpugnacao: [
                {text: "Data", value: "data", width: '5%', sortable: false, class: 'primary--text'},
                {text: "Conteúdo", value: "mensagem", width: '75%', sortable: false, class: 'primary--text'},
                {text: "Anexo", value: "url", width: '15%', sortable: false, class: 'primary--text'},
                {text: 'Respostas', align: 'center', width: '2%', sortable: false, class: 'primary--text'}
            ]
        }
    },
    computed: {
        headersSelecionados() {
            return this.tipo === "Impugnação" ? this.headersImpugnacao : this.headersEsclarecimento;
        }
    },
    methods: {
        abrirModalRespostas(respostas, tipo) {
            this.$emit('abrirModalRespostas', respostas, tipo)
        },
        downloadAnexo(anexo) {
            this.$emit('downloadAnexo', anexo)
        }
    }
}
</script>